import SelectAgency from "pages/Payments/SelectAgency";
import SelectMDA from "pages/Payments/SelectMDA";
import SelectRegion from "pages/Payments/SelectRegion";
import React, { useMemo } from "react";
import {
  Row,
  Col,
  Label,
  Input,
  FormFeedback,
  Card,
  CardBody,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import SelectFile from "./SelectFile";
import { useProfile } from "Components/Hooks/UserHooks";
import { isAllowed } from "common/lib/permissionUtils";
import TimelineInput from "./TimelineInput";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const OtherForm = ({ validation }: { validation: any }) => {
  const { userProfile } = useProfile();

  const canSelectAgency = useMemo(() => {
    return isAllowed(userProfile?.permissions, [
      {
        resource: "payment",
        action: "create",
      },
    ]);
  }, [userProfile?.permissions]);

  return (
    <>
      {/* <SelectRequestType validation={validation} /> */}
      <Card>
        <CardBody>
          <Row>
            <Col md={12} className="mb-3">
              <Label htmlFor="requestTitle" className="form-label">
                Request Title
              </Label>
              <Input
                name="requestTitle"
                id="requestTitle"
                className="form-control"
                placeholder="Enter request title"
                type="text"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.requestTitle || ""}
                invalid={
                  validation.touched.requestTitle &&
                  validation.errors.requestTitle
                }
              />
              <FormFeedback>{validation.errors.requestTitle}</FormFeedback>
            </Col>
            <Col md={6} className="mb-3">
              <SelectRegion validation={validation} />
            </Col>
            <Col md={6} className="mb-3">
              <SelectMDA validation={validation} />
            </Col>
            {/* <Col md={3} className="mb-3">
          <SelectEntity validation={validation} />
        </Col> */}
            {canSelectAgency && (
              <Col md={6} className="mb-3">
                <SelectAgency validation={validation} />
              </Col>
            )}
            <Col md={3} className="mb-3">
              <Label htmlFor="dateOfRequest-field" className="form-label">
                Date of Request
              </Label>
              {/* @ts-ignore */}
              <Flatpickr
                name="dateOfRequest"
                id="dateOfRequest-field"
                className="form-control"
                placeholder="Select start date"
                options={{
                  enableTime: false,
                  altInput: false,
                  altFormat: "d M, Y",
                  dateFormat: "d M, Y",
                }}
                onChange={(e) => {
                  validation.setFieldValue("dateOfRequest", e[0]);
                }}
                value={validation.values.dateOfRequest || ""}
              />
              {validation.touched.dateOfRequest &&
              validation.errors.dateOfRequest ? (
                <FormFeedback type="invalid">
                  {validation.errors.dateOfRequest}
                </FormFeedback>
              ) : null}
            </Col>
            <Col md={3} className="mb-3">
              <Label htmlFor="totalValueOfRequest" className="form-label">
                Total Value of Request (USD)
              </Label>
              <Input
                type="number"
                name="totalValueOfRequest"
                placeholder="Enter total value of request"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.totalValueOfRequest || ""}
                invalid={
                  validation.touched.totalValueOfRequest &&
                  validation.errors.totalValueOfRequest
                }
              />
              <FormFeedback>
                {validation.errors.totalValueOfRequest}
              </FormFeedback>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <Row>
            <Col md={6}>
              <TimelineInput validation={validation} />
            </Col>
            <Col md={3} className="mb-3">
              <Label htmlFor="periodInMonths" className="form-label">
                Period in Months
              </Label>
              <Input
                type="number"
                name="periodInMonths"
                placeholder="Enter period in months"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.periodInMonths || ""}
                invalid={
                  validation.touched.periodInMonths &&
                  validation.errors.periodInMonths
                }
              />
              <FormFeedback>{validation.errors.periodInMonths}</FormFeedback>
            </Col>
            <Col md={3} className="mb-3">
              <Label htmlFor="requestedSalary" className="form-label">
                Funding Status
              </Label>
              <select
                name="fundingStatus"
                id="fundingStatus"
                className="form-control"
                data-choices
                data-choices-search-false
                onChange={validation.handleChange}
                value={validation.values.fundingStatus}
              >
                <option value="">Select funding status</option>
                <option value={"In-progress"}>In-progress</option>
                <option value={"Pending"}>Pending</option>
                <option value={"Completed"}>Completed</option>
                <option value={"Denied"}>Denied</option>
              </select>
            </Col>
          </Row>

          <>
            <Row>
              <Col md={6} className="mb-3">
                <Label htmlFor="positionTitle" className="form-label">
                  Position Titles
                </Label>
                <Input
                  name="positionTitle"
                  id="positionTitle"
                  className="form-control"
                  placeholder="Enter position title"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.positionTitle || ""}
                  invalid={
                    validation.touched.positionTitle &&
                    validation.errors.positionTitle
                  }
                />
                <FormFeedback>{validation.errors.positionTitle}</FormFeedback>
              </Col>
              <Col md={3} className="mb-3">
                <Label htmlFor="noOfPositionsRequested" className="form-label">
                  Number of Positions Requested
                </Label>
                <Input
                  type="number"
                  name="noOfPositionsRequested"
                  placeholder="Enter number of positions requested"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.noOfPositionsRequested || ""}
                  invalid={
                    validation.touched.noOfPositionsRequested &&
                    validation.errors.noOfPositionsRequested
                  }
                />
                <FormFeedback>
                  {validation.errors.noOfPositionsRequested}
                </FormFeedback>
              </Col>

              <Col md={3} className="mb-3">
                <Label htmlFor="requestedSalary" className="form-label">
                  Requested Salary
                </Label>
                <Input
                  type="number"
                  name="requestedSalary"
                  placeholder="Enter requested salary"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.requestedSalary || ""}
                  invalid={
                    validation.touched.requestedSalary &&
                    validation.errors.requestedSalary
                  }
                />
                <FormFeedback>{validation.errors.requestedSalary}</FormFeedback>
              </Col>
            </Row>

            <Row>
              <Col md={6} className="mb-3">
                <Label htmlFor="requestDescription" className="form-label">
                  Review of Request
                </Label>
                {/* <Input
                  type="textarea"
                  name="reviewOfRequest"
                  id="reviewOfRequest"
                  rows={4}
                  placeholder="Enter review of request"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.reviewOfRequest || ""}
                  invalid={
                    validation.touched.reviewOfRequest &&
                    validation.errors.reviewOfRequest
                  }
                /> */}
                <CKEditor
                  editor={ClassicEditor}
                  data={validation.values.reviewOfRequest || ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    validation.setFieldValue("reviewOfRequest", data);
                  }}
                  onBlur={() => {
                    validation.handleBlur("reviewOfRequest");
                  }}
                />
                <FormFeedback>{validation.errors.reviewOfRequest}</FormFeedback>
              </Col>
              <Col md={6} className="mb-3">
                <Label htmlFor="requestDescription" className="form-label">
                  Additional Details
                </Label>
                {/* <Input
                  type="textarea"
                  name="additionalDetails"
                  id="additionalDetails"
                  rows={4}
                  placeholder="Enter additional details"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.additionalDetails || ""}
                  invalid={
                    validation.touched.additionalDetails &&
                    validation.errors.additionalDetails
                  }
                /> */}
                <CKEditor
                  editor={ClassicEditor}
                  data={validation.values.additionalDetails || ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    validation.setFieldValue("additionalDetails", data);
                  }}
                  onBlur={() => {
                    validation.handleBlur("additionalDetails");
                  }}
                />
                <FormFeedback>
                  {validation.errors.additionalDetails}
                </FormFeedback>
              </Col>
            </Row>
          </>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <Row>
            <Col md={12} className="mb-3">
              <SelectFile validation={validation} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default OtherForm;
